<template>
    <el-dialog title="Modifier la marque" v-loading="loader" :visible.sync="display" width="50%">
        <span>Changer la marque pour les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formBrand" ref="form" :model="form">
            <el-form-item prop="brand_id" label="Marque">
                <el-select clearable v-model="form.brand_id" placeholder="Marques" filterable>
                    <el-option v-for="item in brandsOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <div class="switch-footer">
                <el-switch active-text="Syncronisé ?" v-model="form.sync" ></el-switch>
            </div>

            <div>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
            </div>

        </div>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            brandsOptions: [],
            form: {
                brand_id: null,
                sync: false,
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    mounted() {
        axios.get('/brands').then(r => {
            this.brandsOptions = r.data.data;
        });
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var brand_id = this.form.brand_id;
            if (!brand_id) return;
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                brand_id,
                mode: 'brand',
                sync: this.form.sync,
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.form.sync = false;
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>

<style scoped>
.switch-footer {
    text-align: left;
    margin-bottom: 10px;
}
</style>
